// Module
var code = "<div class=\"code-weight-badge\">\n  <badge :text=\"text\" icon-name=\"ion-cube\" theme=\"success\"/>\n</div>\n";
// Exports
export default code;